/**
 * Extract the GA Client ID from the _ga cookie
 * The _ga cookie format is: GA1.2.XXXXXXXXXX.XXXXXXXXXX
 * The client ID is the last two parts: XXXXXXXXXX.XXXXXXXXXX
 */
export function getGAClientId(): string | undefined {
  if (typeof document === 'undefined') return undefined;

  try {
    const gaCookie = document.cookie.split('; ').find((row) => row.startsWith('_ga='));

    if (!gaCookie) return undefined;

    const value = gaCookie.split('=')[1];
    if (!value) return undefined;

    // Extract client ID (last two parts separated by dots)
    const parts = value.split('.');
    if (parts.length >= 4) {
      return `${parts[2]}.${parts[3]}`;
    }

    return undefined;
  } catch {
    return undefined;
  }
}
